// removed by extract-text-webpack-plugin
module.exports = {"go-to-shop-mobile":"go-to-shop-mobile__27Ibb","header":"header__r8-rs","register":"register__z7I4q","hide":"hide__27ZO5"};


//////////////////
// WEBPACK FOOTER
// ./components/header/mobile/MobileHeader.scss
// module id = 8iDW
// module chunks = 1